import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { brDateKey, type PeriodMode, weekLabel } from "../lib/week";

export function PeriodSelector({ mode, from, to, onMode, onPrevious, onToday, onNext, onCustomFrom, onCustomTo }: {
  mode: PeriodMode;
  from: string;
  to: string;
  onMode: (mode: PeriodMode) => void;
  onPrevious: () => void;
  onToday: () => void;
  onNext: () => void;
  onCustomFrom: (value: string) => void;
  onCustomTo: (value: string) => void;
}) {
  const weekly = ["current_week", "next_week", "weekly"].includes(mode);
  return <div className="period-selector">
    <div className="period-preset">
      <CalendarDays size={17}/>
      <select aria-label="Período financeiro" value={mode} onChange={(event) => onMode(event.target.value as PeriodMode)}>
        <option value="today">Hoje</option>
        <option value="current_week">Esta semana</option>
        <option value="next_week">Próxima semana</option>
        <option value="weekly">Semanal</option>
        <option value="monthly">Mensal</option>
        <option value="custom">Personalizado</option>
      </select>
    </div>
    {mode === "custom" ? <div className="custom-period">
      <input type="date" aria-label="Data inicial" value={from} onChange={(event) => onCustomFrom(event.target.value)}/>
      <span>até</span>
      <input type="date" aria-label="Data final" value={to} onChange={(event) => onCustomTo(event.target.value)}/>
    </div> : <div className="period-navigation">
      {weekly && <button type="button" className="period-arrow" onClick={onPrevious} title="Semana anterior"><ChevronLeft size={17}/><span>Semana anterior</span></button>}
      <div className="period-current"><strong>{weekly ? weekLabel(from) : `${brDateKey(from)} a ${brDateKey(to)}`}</strong><span>{brDateKey(from)} a {brDateKey(to)}</span></div>
      {weekly && <button type="button" className="button button-ghost button-small" onClick={onToday}>Hoje</button>}
      {weekly && <button type="button" className="period-arrow" onClick={onNext} title="Próxima semana"><span>Próxima semana</span><ChevronRight size={17}/></button>}
    </div>}
  </div>;
}
